import { render, staticRenderFns } from "./dadosContato.vue?vue&type=template&id=7801ad0a"
import script from "./dadosContato.ts?vue&type=script&lang=js&external"
export * from "./dadosContato.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7801ad0a')) {
      api.createRecord('7801ad0a', component.options)
    } else {
      api.reload('7801ad0a', component.options)
    }
    module.hot.accept("./dadosContato.vue?vue&type=template&id=7801ad0a", function () {
      api.rerender('7801ad0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/atendimento/dadosContato/dadosContato.vue"
export default component.exports